"use client";

import { BlurFade } from "@/components/ui/blur-fade";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { markdownComponents } from "@/lib/markdown-config";

interface PolicyPageProps {
  content: string;
}

const PolicyPage = ({ content }: PolicyPageProps) => {
  return (
    <section className="py-24 bg-white">
      <div className="container max-w-4xl mx-auto px-6">
        <BlurFade delay={0.1}>
          <div className="prose prose-zinc max-w-none">
            <ReactMarkdown
              remarkPlugins={[remarkGfm]}
              components={markdownComponents}
            >
              {content}
            </ReactMarkdown>
          </div>
        </BlurFade>
      </div>
    </section>
  );
};

export default PolicyPage;
